/* eslint-disable no-empty */
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export function fulfilled(state, payload, result) {
  const {ausbildungsplan, ausbildungsnachweise, praxisaufgaben} = result
  return {
    ...state,
    isLoading: false,
    ausbildungsplan,
    ausbildungsnachweise,
    praxisaufgaben,
  }
}

export async function action() {
  const limit = 5

  let ausbildungsplan

  try {
    ausbildungsplan = await Api.readAusbildungsplanForAusbilderDashboard(limit)
  } catch {}

  let ausbildungsnachweise
  try {
    ausbildungsnachweise = await Api.getAusbildungsnachweiseAusbilderDashboard(limit)
  } catch {}

  let praxisaufgaben
  try {
    praxisaufgaben = await Api.readPraxisaufgabenForAusbilderDashboard(limit + 1)
  } catch {}

  const result = {
    ausbildungsplan,
    ausbildungsnachweise,
    praxisaufgaben,
  }
  return result
}
